import React, { useEffect } from 'react';
import {isAndroid, isIOS, isMobile} from 'react-device-detect';

import './App.scss';
import images from './assets/images.js';
import strings from './assets/strings/index.js';


import {Link} from 'react-router-dom';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Navigation, Pagination} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

SwiperCore.use([Navigation, Pagination]);

const SCREENSHOT_LIST = [
  {image: images.web_01, alt: 'apnea'},
  {image: images.web_02, alt: 'freediving'},
  {image: images.web_03, alt: 'freedive'},
  {image: images.web_04, alt: 'spearfishing'},
  {image: images.web_05, alt: 'training'},
  {image: images.web_06, alt: 'co2 Training'},
  {image: images.web_07, alt: 'o2 Training'},
  {image: images.web_08, alt: 'license'},
  {image: images.web_09, alt: 'competitions'},
  {image: images.web_10, alt: 'logbook'},
];

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onClickIcon = () => {
    if (isMobile) {
      isAndroid ? onClickPlaystore() : onClickAppstore();
    }
  };

  const onClickPlaystore = () => {
    const url =
      isMobile && isAndroid
        ? 'market://details?id=com.giftsets.freedive'
        : 'http://play.google.com/store/apps/details?id=com.giftsets.freedive';
    const target = isMobile ? undefined : '_blank';
    window.open(url, target);
  };

  const onClickAppstore = () => {
    const url =
      isMobile && isIOS
        ? 'itms-apps://itunes.apple.com/app/id1567940653'
        : 'https://apps.apple.com/us/app/freedive-training-learn/id1567940653';
    const target = isMobile ? undefined : '_blank';
    window.open(url, target);
  };

  const onClickInstagram = () => {
    const url = 'https://instagram.com/freedive_ai.app';
    window.open(url);
  };

  const renderSwiperSlide = (item, index) => {
    return (
      <SwiperSlide>
        <img src={item.image} alt={item.alt} />
      </SwiperSlide>
    );
  };

  return (
    <div className={"App"}>
      <header className={"App-header"}>
        <div style={{display: 'flex', alignItems: 'center'}}>
          <img src={images.ic_app} className={"App-logo-small"} alt={"Freediving App Logo"} />
          <h1 className={"App-title"}>{strings.title}</h1>
        </div>
        {strings.getLanguage().startsWith('ko') && (
          <Link to="/equipments" style={{color: '#3399ff', textDecoration: 'none', fontWeight: 600, fontSize: '0.875rem'}}>
            {'장비 가이드 →'}
          </Link>
        )}
      </header>

      <main className={"App-main"}>
        <section className={"Hero-section"}>
          <div className={"Hero-text"}>
            <h2 className={"Hero-headline"}>{strings.heroHeadline}</h2>
            <p className={"Hero-subheadline"}>
              {strings.heroSubheadline}
            </p>
            <div className={"App-download-container"}>
              <a onClick={onClickPlaystore} style={{cursor: 'pointer'}}>
                <img
                  src={images.download_playstore}
                  className={"App-download"}
                  alt={"FreeDive Training Android App Free Download"}
                />
              </a>
              <div className={"Divider"} />
              <a onClick={onClickAppstore} style={{cursor: 'pointer'}}>
                <img
                  src={images.download_appstore}
                  className={"App-download"}
                  alt={"FreeDive Training iPhone App Free Download"}
                />
              </a>
            </div>
          </div>
          <div className={"Hero-visual"}>
            <img
              src={images.ic_app}
              className={"App-icon"}
              alt={"FreeDive App Icon"}
              onClick={onClickIcon}
            />
          </div>
        </section>

        <section className={"Features-section"}>
          <div className={"Features-header"}>
            <h2 className={"Section-title"}>{strings.featuresHeader}</h2>
            <p className={"Section-subtitle"}>
              {strings.featuresSubtitle}
            </p>
          </div>
          <div className={"Features-grid"}>
            <div className={"Feature-card"}>
              <div className={"Feature-icon"}>{'🫁'}</div>
              <h3 className={"Feature-title"}>{strings.feature1Title}</h3>
              <p className={"Feature-description"}>
                {strings.feature1Desc}
              </p>
            </div>
            <div className={"Feature-card"}>
              <div className={"Feature-icon"}>{'📖'}</div>
              <h3 className={"Feature-title"}>{strings.feature2Title}</h3>
              <p className={"Feature-description"}>
                {strings.feature2Desc}
              </p>
            </div>
            <div className={"Feature-card"}>
              <div className={"Feature-icon"}>{'🏆'}</div>
              <h3 className={"Feature-title"}>{strings.feature3Title}</h3>
              <p className={"Feature-description"}>
                {strings.feature3Desc}
              </p>
            </div>
          </div>
        </section>

        <section className={"Screenshots-section"}>
          <h3 className={"Section-title"}>{strings.screenshotsTitle}</h3>
          <div className={"Swiper-container"}>
            <Swiper
              direction={'horizontal'}
              slidesPerView={1}
              spaceBetween={20}
              mousewheel={true}
              pagination={{
                clickable: true,
              }}
              modules={[Pagination]}
              scrollbar={{draggable: true}}
              breakpoints={{
                720: { slidesPerView: 2, spaceBetween: 20 },
                1080: { slidesPerView: 3, spaceBetween: 30 },
                1440: { slidesPerView: 4, spaceBetween: 30 },
                1800: { slidesPerView: 5, spaceBetween: 40 },
                2160: { slidesPerView: 6, spaceBetween: 40 },
              }}>
              {SCREENSHOT_LIST.map((item, index) => {
                return renderSwiperSlide(item, index);
              })}
            </Swiper>
          </div>
        </section>
      </main>

      <footer className={"App-footer"}>
        <a
          className={"App-link-container"}
          onClick={onClickInstagram}
          style={{cursor: 'pointer'}}>
          <img
            src={images.ic_instagram}
            className={"App-link-icon"}
            alt={"freedive_app Instagram"}
          />
          <p className={"App-link-text"}>{'freedive_ai.app'}</p>
        </a>
        <p className={"Copyright"}>{strings.copyright}</p>
      </footer>
    </div>
  );
};

export default Home;
